import { render, staticRenderFns } from "./CreatePlanSummary.vue?vue&type=template&id=67f20b84&"
import script from "./CreatePlanSummary.vue?vue&type=script&lang=js&"
export * from "./CreatePlanSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports